module.exports = __webpack_public_path__ + "static/media/graph-paper.3a518a85.png";